import { getMap, getMapView, useMapStore } from '@/map/mapStore';
import { useLayerRegistry } from '@/map/layers/registry';
import { getSelectionSummary } from '@/state/selectionStore';
import type { Tool } from './types';

type Input = Record<string, never>;

export const viewState: Tool<Input> = {
  name: 'view_state',
  description:
    'Snapshot the current map state: basemap, scale/zoom, extent, visible layer ids, and the click selection (if any). Cheap — call instead of multiple `describe`/`get_selection`/`list_layers` round-trips. Each chat turn already pre-packs this into the system prompt; only call when you need a fresher reading.',
  input_schema: {
    type: 'object',
    properties: {},
    additionalProperties: false,
  },
  execute: () => {
    const view = getMapView();
    if (!view) return { ready: false };

    const map = getMap();
    const records = useLayerRegistry.getState().records;
    const visibleIds: string[] = [];
    if (map) {
      for (const r of records) {
        const layer = map.layers.find((l) => l.id === r.id);
        if (layer && layer.visible !== false) visibleIds.push(r.id);
      }
    }

    const ext = view.extent;
    return {
      ready: true,
      basemap_id: useMapStore.getState().basemapId,
      scale: typeof view.scale === 'number' ? view.scale : undefined,
      zoom: typeof view.zoom === 'number' ? view.zoom : undefined,
      extent: ext
        ? {
            xmin: ext.xmin,
            ymin: ext.ymin,
            xmax: ext.xmax,
            ymax: ext.ymax,
            wkid: ext.spatialReference?.wkid ?? undefined,
          }
        : undefined,
      visible_layer_ids: visibleIds,
      selection: getSelectionSummary() ?? undefined,
    };
  },
};
